import { takeEvery, select, call, put, delay } from "redux-saga/effects"

// Types
import NotificationsTypes from "Containers/Notifications/types"

// Actions
import {
  getNotificationSSEAction,
} from "Containers/Notifications/actions"

// Utils
import { buildTemplateNotificationInput } from "Containers/Notifications/notifications.utils"

// Selectors

import {
  selectCurrentToken,
} from "Containers/Login/selectors"

// Utils
import { config } from "Utils/config"


function* postNotification({ payload }) {
  const token = yield select(selectCurrentToken)
  const infosNotif = payload?.infos_notif
  console.log("🔍 payload reçu :", payload)
  console.log("🔍 infosNotif :", infosNotif)

  let templateId

  // Vérifier si le template existe
  const templateResponse = yield call(getTemplateNotification, {
    payload: { templateName: infosNotif?.name_template },
  })

  if (templateResponse && templateResponse._id) {
    templateId = templateResponse._id
    console.log("✅ Template existant trouvé avec ID :", templateId)
  } else {
    console.log("🛠 Aucun template trouvé, création en cours...")
    yield call(postTemplateNotification, { payload: infosNotif })
    // Attendre un court instant pour s'assurer que le template est bien enregistré
    yield delay(500)

    const newTemplateResponse = yield call(getTemplateNotification, {
      payload: { templateName: infosNotif?.name_template },
    })

    if (newTemplateResponse && newTemplateResponse._id) {
      templateId = newTemplateResponse._id
      console.log("✅ Nouveau template créé avec ID :", templateId)
    } else {
      console.error("❌ Impossible de récupérer l'ID du template après création !")
      return
    }
  }

  // Vérification finale avant d'envoyer la notification
  if (!templateId) {
    console.error("❌ Aucun templateId trouvé, impossible d'envoyer la notification !")
    return
  }

  const query = `
    mutation SendNotification($input: createNotifInput!) {
      sendNotification(input: $input)
    }
  `

  const variables = {
    input: {
      templateId,
      templateName: infosNotif?.name_template,
      variables: {
        ...infosNotif?.variables,
        targetsIds: infosNotif?.to_principals,
        channel_id: infosNotif?.channel_id,
      },
    },
  }

  try {
    const response = yield call(fetch, `${config?.APOLLO_SERVER_URL}/graphql`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ query, variables }),
    })

    const result = yield response.json()
    console.log("📩 Résultat de postNotification :", result)

    if (result.errors) {
      console.error(`[GraphQL] => postNotification => ERROR =>`, result.errors)
    } else {
      yield put(getNotificationSSEAction())
    }
  } catch (err) {
    console.error(`[GraphQL] => postNotification => ERROR =>`, err)
  }
}

function* getTemplateNotification({ payload }) {
  const token = yield select(selectCurrentToken)

  const query = `
    query Query($templateName: String!) {
      getNotificationTemplate(templateName: $templateName)
    }
  `

  const variables = {
    templateName: payload?.templateName,
  }

  try {
    const response = yield call(fetch, `${config?.APOLLO_SERVER_URL}/graphql`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ query, variables }),
    })

    const result = yield response.json()
    console.log("📩 Résultat de getTemplateNotification :", result)

    if (result.errors) {
      console.error("❌ Erreur GraphQL :", result.errors)
      return null
    }

    // Vérifier si le template existe
    if (!result.data || !result.data.getNotificationTemplate) {
      console.warn("⚠️ Aucun template trouvé pour", payload?.templateName)
      return null
    }

    return result.data.getNotificationTemplate
  } catch (err) {
    console.error("❌ Erreur lors de getTemplateNotification :", err)
    return null
  }
}

function* postTemplateNotification({ payload }) {
  const token = yield select(selectCurrentToken)
  console.log("payload ===", payload)

  const query = `
  mutation PostTemplateNotification($input: CreateNotifTemplateInput!) {
    postTemplateNotification(input: $input)
  }
`
  const variables = {
    input: buildTemplateNotificationInput(payload),
  }

  try {
    const response = yield call(fetch, `${config?.APOLLO_SERVER_URL}/graphql`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ query, variables }),
    })

    const result = yield response.json()
    console.log("postTemplateNotification result =>", result)
    if (result.errors) {
      console.error(`[GraphQL] => postTemplateNotification => ERROR =>`, result.errors)
    } else {
      yield put(getNotificationSSEAction())
    }
  } catch (err) {
    console.error(`[GraphQL] => postTemplateNotification => ERROR =>`, err)
  }
}

// ***************************** //
//              Sagas            //
// ***************************** //
function* notificationsSaga() {
  yield takeEvery(NotificationsTypes.POST_NOTIFICATION, postNotification)
}

export default notificationsSaga
